import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetIncomingRequestPolicyRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetIncomingRequestPolicyResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setIncomingRequestPolicy = (request: SetIncomingRequestPolicyRequest, options?: CashRequestOptions) =>
  post<SetIncomingRequestPolicyRequest, SetIncomingRequestPolicyResponse>(
    '/2.0/cash/set-incoming-request-policy',
    request,
    { ...options, rejectOnError: true }
  )
